"use client";

import React, { useState } from "react";

//Styles
import * as S from "./styles";
import { InputPasswordProps } from "@/types";

const InputPassword: React.FC<InputPasswordProps> = ({
  className,
  label,
  name,
  value,
  onChange,
  onKeyDown,
  validation,
}) => {
  const [type, setType] = useState("password");
  const [icon, setIcon] = useState<"eyes" | "notEyes">("eyes");

  const togglePasswordVisibility = (e: React.MouseEvent) => {
    setType((prevType) => (prevType === "password" ? "text" : "password"));
    setIcon((prevIcon) => (prevIcon === "eyes" ? "notEyes" : "eyes"));
  };

  return (
    <S.InputGroupPassword>
      <S.InputPassword
        label={label}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        className={className}
        onKeyDown={onKeyDown}
        validation={validation}
      />
      <S.ShowHiddendPassword icon={icon} onClick={togglePasswordVisibility} />
    </S.InputGroupPassword>
  );
};

export default InputPassword;
